import { Link } from 'react-router-dom';

const footerCategories = [
  { name: 'Shoes', url: 'https://kaspreadsheet.com/category-911-Shoes.html' },
  { name: 'Hoodies/Sweaters', url: 'https://kaspreadsheet.com/search-912/name/Shoes.html' },
  { name: 'T-Shirts', url: 'https://kaspreadsheet.com/search-913/name/Shoes.html' },
  { name: 'Jackets', url: 'https://kaspreadsheet.com/search-914/name/Shoes.html' },
  { name: 'Accessories', url: 'https://kaspreadsheet.com/search-920/name/Shoes.html' },
  { name: 'Bags', url: 'https://kaspreadsheet.com/search-921/name/Shoes.html' },
];

const Footer = () => {
  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const honeypot = form.querySelector<HTMLInputElement>('.field-website_alt');
    if (honeypot && honeypot.value.trim() !== '') {
      const successEl = document.getElementById('newsletter-success');
      if (successEl) successEl.style.display = 'block';
      form.reset();
      return;
    }

    const formData = new FormData(form);
    try {
      const res = await fetch('https://readdy.ai/api/form/d97otoig3iubr452i68g', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });
      const text = await res.text();
      let parsed;
      try { parsed = JSON.parse(text); } catch { parsed = null; }
      if (res.ok && parsed?.code === 'OK') {
        const successEl = document.getElementById('newsletter-success');
        if (successEl) successEl.style.display = 'block';
        const errorEl = document.getElementById('newsletter-error');
        if (errorEl) errorEl.style.display = 'none';
        form.reset();
      } else {
        const msg = parsed?.meta?.message || parsed?.message || 'Something went wrong. Please try again.';
        const errorEl = document.getElementById('newsletter-error');
        if (errorEl) {
          errorEl.textContent = msg;
          errorEl.style.display = 'block';
        }
      }
    } catch {
      const errorEl = document.getElementById('newsletter-error');
      if (errorEl) {
        errorEl.textContent = 'Network error. Please try again.';
        errorEl.style.display = 'block';
      }
    }
  };

  return (
    <footer className="w-full bg-foreground-900 text-white">
      <div className="px-6 md:px-10 lg:px-20 py-16 max-w-[1400px] mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-14">
          <div>
            <h3 className="font-heading text-2xl md:text-3xl font-bold mb-4">
              Join the Hub
            </h3>
            <p className="text-foreground-300 text-sm leading-relaxed mb-6">
              Subscribe to receive the latest Hipobuy Spreadsheet updates, new category alerts, and exclusive shopping tips straight to your inbox.
            </p>
            <form
              id="newsletter-form"
              data-readdy-form
              onSubmit={handleSubmit}
              className="flex flex-col gap-3"
            >
              <input
                type="text"
                name="website_alt"
                className="field-website_alt"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                readOnly
              />
              <input
                type="email"
                name="email"
                placeholder="Enter your email"
                required
                className="bg-transparent border-b border-foreground-600 text-white placeholder-foreground-500 text-sm py-2.5 px-0 outline-none focus:border-accent-400 transition-colors"
              />
              <button
                type="submit"
                className="inline-flex items-center gap-2 px-6 py-2.5 rounded-full bg-white text-foreground-900 text-sm font-semibold hover:bg-accent-100 transition-all cursor-pointer whitespace-nowrap self-start"
              >
                Subscribe
                <i className="ri-arrow-right-line"></i>
              </button>
              <p
                id="newsletter-success"
                className="text-accent-400 text-sm mt-1"
                style={{ display: 'none' }}
              >
                Thank you for subscribing!
              </p>
              <p
                id="newsletter-error"
                className="text-primary-400 text-sm mt-1"
                style={{ display: 'none' }}
              ></p>
            </form>
          </div>

          <div>
            <p className="text-xs font-semibold text-foreground-400 uppercase tracking-wider mb-5">Quick Links</p>
            <div className="flex flex-col gap-3">
              <Link to="/" className="text-foreground-200 text-sm hover:text-white transition-colors cursor-pointer underline">Home</Link>
              <Link to="/what-is-hipobuy-sheet" className="text-foreground-200 text-sm hover:text-white transition-colors cursor-pointer underline">Hipobuy Sheet Guide</Link>
              <a href="#categories" className="text-foreground-200 text-sm hover:text-white transition-colors cursor-pointer underline">Categories</a>
              <a href="#articles" className="text-foreground-200 text-sm hover:text-white transition-colors cursor-pointer underline">Latest Guides</a>
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-foreground-200 text-sm hover:text-white transition-colors cursor-pointer underline">Kaspreadsheet</a>
            </div>
          </div>

          <div>
            <p className="text-xs font-semibold text-foreground-400 uppercase tracking-wider mb-5">Top Categories</p>
            <div className="flex flex-col gap-3 mb-8">
              {footerCategories.map((cat) => (
                <a
                  key={cat.name}
                  href={cat.url}
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-foreground-200 text-sm hover:text-white transition-colors cursor-pointer underline"
                >
                  {cat.name}
                </a>
              ))}
            </div>
          </div>

          <div>
            <p className="text-xs font-semibold text-foreground-400 uppercase tracking-wider mb-5">Platform Guides</p>
            <div className="flex flex-col gap-3 mb-8">
              <Link to="/kakobuy-spreadsheet" className="text-foreground-200 text-sm hover:text-white transition-colors cursor-pointer underline">Kakobuy Spreadsheet</Link>
              <Link to="/cssbuy-spreadsheet" className="text-foreground-200 text-sm hover:text-white transition-colors cursor-pointer underline">CSSBuy Spreadsheet</Link>
              <Link to="/superbuy-spreadsheet" className="text-foreground-200 text-sm hover:text-white transition-colors cursor-pointer underline">Superbuy Spreadsheet</Link>
              <Link to="/oopbuy-spreadsheet" className="text-foreground-200 text-sm hover:text-white transition-colors cursor-pointer underline">Oopbuy Spreadsheet</Link>
            </div>
            <p className="text-xs font-semibold text-foreground-400 uppercase tracking-wider mb-3">Contact</p>
            <p className="text-foreground-300 text-sm">hello@hipobuyspreads.store</p>
          </div>
        </div>

        <div className="border-t border-foreground-800 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-5">
            <a href="#" className="text-foreground-400 text-sm hover:text-white transition-colors cursor-pointer underline">Twitter</a>
            <a href="#" className="text-foreground-400 text-sm hover:text-white transition-colors cursor-pointer underline">Pinterest</a>
            <a href="#" className="text-foreground-400 text-sm hover:text-white transition-colors cursor-pointer underline">Reddit</a>
          </div>
          <p className="text-foreground-500 text-sm">
            &copy; {new Date().getFullYear()} Hipobuy Spreadsheet Hub. All rights reserved.
          </p>
          <div className="flex items-center gap-5">
            <a href="#" className="text-foreground-400 text-sm hover:text-white transition-colors cursor-pointer underline">Privacy Policy</a>
            <a href="#" className="text-foreground-400 text-sm hover:text-white transition-colors cursor-pointer underline">Terms</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;